import { create } from 'zustand';

interface UiState {
  ceoMode: boolean;
  toggleCeoMode: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  ceoMode: localStorage.getItem('axis_ceo_mode') === 'true',
  toggleCeoMode: () =>
    set((state) => {
      const next = !state.ceoMode;
      localStorage.setItem('axis_ceo_mode', String(next));
      return { ceoMode: next };
    }),
}));
